import React from 'react'

export const Icon = ({ icon }) => {
  switch (icon) {
    case 'phone':
      return (
        <span className="mt-1 mr-5 transform scale-125">
          <svg
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 10.9467v2.3573c.0001.1688-.0639.3313-.1789.4548-.1151.1235-.2727.1987-.4411.2105-.2913.02-.5293.0307-.7133.0307C6.77533 14 2 9.22467 2 3.33333c0-.184.01-.422.03067-.71333.01181-.16837.08705-.32599.21053-.44106.12348-.11507.28602-.17902.4548-.17894h2.35733c.0827-.00008.16247.03057.22382.08601.06136.05544.09991.13171.10818.21399.01534.15333.02934.27533.04267.368.13249.92462.404 1.82389.80533 2.66733.06334.13334.022.29267-.098.378l-1.43866 1.028C5.5763 8.79097 7.2097 10.4244 9.25933 11.304L10.286 9.868c.042-.05867.1032-.10075.173-.1189.0698-.01815.1438-.01123.209.01957.8433.40053 1.7424.67143 2.6667.80333.0926.0133.2146.028.3666.0427.0822.0084.1583.047.2136.1084.0553.0613.0859.141.0858.2236H14z"
              fill="#FFE928"
            />
          </svg>
        </span>
      )
    case 'location':
      return (
        <span className="mt-1 mr-5 transform scale-125">
          <svg
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.2427 11.576L8 15.8187 3.75734 11.576c-.83911-.8391-1.41055-1.90823-1.64205-3.07211-.23151-1.16389-.11269-2.37028.34144-3.46663.45413-1.09636 1.22317-2.03342 2.20986-2.69271C5.65328 1.68527 6.81332 1.33337 8 1.33337c1.18669 0 2.3467.3519 3.3334 1.01118.9867.65929 1.7557 1.59635 2.2099 2.69271.4541 1.09635.5729 2.30274.3414 3.46663-.2315 1.16388-.8029 2.23301-1.642 3.07211zM8 9.99999c.70725 0 1.38552-.28095 1.88562-.78105.50008-.5001.78108-1.17837.78108-1.88562 0-.70724-.281-1.38552-.78108-1.88562C9.38552 4.94761 8.70725 4.66666 8 4.66666c-.70724 0-1.38552.28095-1.88562.78104-.50009.5001-.78104 1.17838-.78104 1.88562 0 .70725.28095 1.38552.78104 1.88562.5001.5001 1.17838.78105 1.88562.78105zm0-1.33333c-.35362 0-.69276-.14048-.94281-.39053-.25004-.25005-.39052-.58919-.39052-.94281 0-.35362.14048-.69276.39052-.94281.25005-.25005.58919-.39052.94281-.39052.35362 0 .69276.14047.94281.39052s.39053.58919.39053.94281c0 .35362-.14048.69276-.39053.94281S8.35362 8.66666 8 8.66666z"
              fill="#FFE928"
            />
          </svg>
        </span>
      )
    case 'mail':
      return (
        <span className="mt-1 mr-5 transform scale-125">
          <svg
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.99999 2H14c.1768 0 .3464.07024.4714.19526.125.12503.1953.2946.1953.47141V13.3333c0 .1768-.0703.3464-.1953.4714-.125.1251-.2946.1953-.4714.1953H1.99999c-.17681 0-.34638-.0702-.4714-.1953-.12502-.125-.19526-.2946-.19526-.4714V2.66667c0-.17681.07024-.34638.19526-.47141C1.65361 2.07024 1.82318 2 1.99999 2zM8.04 7.78867l-4.27467-3.63-.86333 1.016 5.14666 4.37 5.05404-4.37334-.872-1.00866-4.19004 3.626H8.04z"
              fill="#FFE928"
            />
          </svg>
        </span>
      )
    case 'website':
      return (
        <span className="mt-1 mr-5 transform scale-125">
          <svg
            width="16"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.36673 8.66666h3.65133c.11408 2.11124.78704 4.15424 1.95 5.92004-1.45671-.2289-2.79653-.9339-3.80999-2.005-1.01345-1.0712-1.6434-2.4479-1.79134-3.91504zm0-1.33333c.14794-1.46713.77789-2.84388 1.79134-3.91499 1.01346-1.07111 2.35328-1.77619 3.80999-2.00501-1.16296 1.76574-1.83592 3.80876-1.95 5.92H1.36673zm13.26667 0h-3.6513c-.1141-2.11124-.7871-4.15426-1.95004-5.92 1.45674.22882 2.79654.9339 3.81004 2.00501 1.0134 1.07111 1.6434 2.44786 1.7913 3.91499zm0 1.33333c-.1479 1.46714-.7779 2.84384-1.7913 3.91504-1.0135 1.0711-2.3533 1.7761-3.81004 2.005 1.16294-1.7658 1.83594-3.8088 1.95004-5.92004h3.652-.0007zm-8.28 0h3.29333C9.537 10.4663 8.97026 12.2083 8.00006 13.728c-.9702-1.5197-1.53693-3.2617-1.64666-5.06134zm0-1.33333c.10973-1.79966.67646-3.54162 1.64666-5.06133.9702 1.51971 1.53694 3.26167 1.64667 5.06133H6.3534z"
              fill="#FFE928"
            />
          </svg>
        </span>
      )

    default:
      return null
  }
}
